module.exports = __webpack_public_path__ + "static/media/funitygame1.c1245d0e.png";